module.exports = __webpack_public_path__ + "img/au.fbf1be2f.svg";